import React from 'react';
import { Control, UseFormSetValue } from 'react-hook-form';
import { Grid } from '@mui/material';
import { DiscountTypes } from 'api';
import { FormCard, FormInput } from 'components';

interface Props {
  control: Control<DiscountTypes.ItemCreateParams> | undefined;
  setValue: UseFormSetValue<DiscountTypes.ItemCreateParams>;
}

const MaximumDiscountUsesBlock = (props: Props): JSX.Element | null => {
  const { control, setValue } = props;

  return (
    <FormCard title="Maximum discount uses">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormInput
            control={control}
            name="usage_limit"
            inputType="number"
            label="Usage limit"
            tooltip="Number of times this discount can be used in total (leave blank if no limit)"
            rules={{
              onBlur: (e) =>
                setValue(
                  'usage_limit',
                  +e.target.value === 0 ? null : +(+e.target.value).toFixed(2),
                ),
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <FormInput
            control={control}
            name="applies_once_per_customer"
            inputType="switch"
            label="Apply discount once per customer"
          />
        </Grid>
      </Grid>
    </FormCard>
  );
};

export default MaximumDiscountUsesBlock;
